<div class="dropdown" [ngClass]="{ 'dropdown--open': isOpened }" attr.aria-hidden="{{ isDisabled }}">
    <div class="dropdown__vertical-line"></div>

    <span id="select-label" class="default-text hidden" *ngIf="placeholderText && selected">
        {{ placeholderText }}:
    </span>

    <div
        class="dropdown__standard"
        [ngClass]="{ 'has-icon': hasIcon, 'disabled': isDisabled }"
        tabindex="0"
        role="button"
        id="select-button"
        aria-haspopup="listbox"
        [attr.aria-expanded]="isOpened ? true : null"
        [attr.aria-labelledby]="selected ? 'select-label select-button' : null"
        (click)="openClicked($event)"
        (keydown.enter)="openClicked($event)"
        (keydown.space)="openClicked($event)"
        (keydown.arrowup)="openClicked($event)"
        (keydown.arrowdown)="openClicked($event)"
        #dropdownButton
    >
        <ng-content></ng-content>

        <img class="hide-for-wcag" src="assets/icon_arrowdown.svg" alt="" />
        <img class="show-high-contrast-view" src="assets/icon_arrowdown-wcag.svg" alt="" />

        <span id="select-label" class="default-text" *ngIf="placeholderText && !selected">{{ placeholderText }}</span>

        <ng-container *ngIf="type === 'default' && selected && !displayField">
            {{ selected ? selected.display : '' }}
        </ng-container>

        <ng-container *ngIf="type === 'simple' && selected && !displayField">{{ selected }} </ng-container>

        <ng-container
            *ngIf="
                type === 'default' &&
                selected &&
                displayField !== null &&
                selected.translations &&
                selected.translations.length > 0
            "
        >
            {{ selected | translateObjectField: displayField:locale }}
        </ng-container>

        <ng-container
            *ngIf="
                type === 'default' &&
                selected &&
                displayField !== null &&
                (!selected.translations || selected.translations.length === 0)
            "
        >
            {{ selected[displayField] }}
        </ng-container>

        <ng-container *ngIf="type === 'related-card' && selected">
            {{ (selected.name) ? selected.name : selected.card_nr }}
        </ng-container>
    </div>

    <ol
        class="dropdown__choices"
        role="listbox"
        tabindex="-1"
        attr.aria-activedescendant="{{ listItemIdPrefix + selectedIndex }}"
        aria-labelledby="select-label"
    >
        <ng-container *ngIf="type === 'default' && !displayField">
            <ridango-dropdown-default-item
                *ngFor="let item of items; index as i"
                [id]="listItemIdPrefix + i"
                (click)="itemSelected(item, i)"
                [item]="item"
                [isSelected]="selectedIndex === i"
                (keydown)="keyDown($event)"
                #selectItem
            >
                {{ item.display }}
            </ridango-dropdown-default-item>
        </ng-container>

        <ng-container *ngIf="type === 'default' && displayField !== null">
            <ridango-dropdown-default-item
                *ngFor="let item of items; index as i"
                [id]="listItemIdPrefix + i"
                (click)="itemSelected(item, i)"
                [item]="item"
                [isSelected]="selectedIndex === i"
                (keydown)="keyDown($event)"
                #selectItem
            >
                <ng-container *ngIf="item.translations && item.translations.length > 0">
                    {{ item | translateObjectField: displayField:locale }}
                </ng-container>
                <ng-container *ngIf="!item.translations || item.translations.length === 0">
                    {{ item[displayField] }}
                </ng-container>
            </ridango-dropdown-default-item>
        </ng-container>

        <ng-container *ngIf="type === 'simple' && displayField === null">
            <ridango-dropdown-default-item
                *ngFor="let item of items; index as i"
                [id]="listItemIdPrefix + i"
                (click)="itemSelected(item, i)"
                [item]="item"
                [isSelected]="selectedIndex === i"
                (keydown)="keyDown($event)"
                #selectItem
            >
                <ng-container>
                    {{ item }}
                </ng-container>
            </ridango-dropdown-default-item>
        </ng-container>

        <ng-container *ngIf="type === 'related-card'">
            <ridango-dropdown-related-card-item
                *ngFor="let item of items; index as i"
                [id]="listItemIdPrefix + i"
                (click)="itemSelected(item, i)"
                [item]="item"
                [isSelected]="selectedIndex === i"
                (keydown)="keyDown($event)"
                #selectItem
            >
                {{ (item.name) ? item.name : item.card_nr }}
            </ridango-dropdown-related-card-item>
        </ng-container>
    </ol>
</div>
